import axios from "axios-config";
import ConsoleHelper from "utils/ConsoleHelper";

export const fetchDefaultWarehouse = async () => {
  const response = await axios.get("/inventory/warehouse/default");
  return response.data;
};
